import { createContext, useContext, useEffect } from 'react';

/**
 * The supplier shell's breadcrumb (2026-10-23): a BID page names its BID here, and the shell's header reads
 * "BIDs › BID-2026-0048 › Submit Bid" as the reference does. Outside the supplier shell nobody provides it, and the
 * hook does nothing.
 */
export const SupplierCrumbContext = createContext<((rfqNumber: string | null) => void) | null>(null);

export function useSupplierCrumb(rfqNumber: string | null | undefined): void {
  const set = useContext(SupplierCrumbContext);
  useEffect(() => {
    if (!set) return undefined;
    set(rfqNumber ?? null);
    return () => {
      set(null);
    };
  }, [set, rfqNumber]);
}
